import { useState } from "react";
import { cardImageUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";

const RANK = { 1: "Mismo set y número", 2: "Mismo número, otro set", 3: "Nombre parecido" };

const Match = ({ m, onPublish, onDismiss }) => (
  <div className="flex items-center gap-3 p-3 rounded border border-[#262626] bg-[#0A0A0A]" data-testid={`exists-match-${m.id}`}>
    <div className="w-14 h-20 shrink-0 rounded overflow-hidden border border-[#262626] bg-black grid place-items-center">
      {m.image_url ? <img src={cardImageUrl(m.image_url, 200)} alt={m.name_es} className="w-full h-full object-contain" /> : <span className="text-[9px] text-neutral-600">Sin imagen</span>}
    </div>
    <div className="flex-1 min-w-0">
      <div className="font-medium text-white truncate">{m.name_es}</div>
      <div className="text-xs text-neutral-400 leading-snug" data-testid={`exists-match-meta-${m.id}`}>
        {[m.set_name, m.number ? `#${m.number}` : null, m.year].filter(Boolean).join(" · ")}
      </div>
      {m.rank && <div className="text-[10px] uppercase tracking-wider text-neutral-500 mt-0.5">{RANK[m.rank]}</div>}
      <button type="button" onClick={() => onDismiss(m)} className="mt-1 text-[11px] text-amber-300 underline" data-testid={`exists-not-this-${m.id}`}>
        No es esta, es otra versión
      </button>
    </div>
    <Button type="button" onClick={() => onPublish && onPublish(m)} className="bg-[#EF4444] hover:bg-[#DC2626]" data-testid={`exists-publish-${m.id}`}>Publicar esta</Button>
  </div>
);

const DifferentForm = ({ m, busy, onSend, onCancel }) => {
  const [reason, setReason] = useState("");
  return (
    <div className="p-3 rounded border border-amber-500/40 bg-amber-500/5 space-y-2" data-testid="exists-different-form">
      <div className="text-xs text-neutral-300">Descartas: <b className="text-white">{m.name_es}</b> · {[m.set_name, m.number && `#${m.number}`, m.year].filter(Boolean).join(" · ")}</div>
      <label className="block text-xs text-neutral-400">¿Qué la hace distinta? *</label>
      <input value={reason} onChange={(e) => setReason(e.target.value.slice(0, 300))} placeholder="Ej. otro set, otra edición, error de impresión"
        className="w-full h-10 bg-[#171717] border border-[#262626] rounded px-3 text-sm" data-testid="exists-different-reason" />
      <div className="flex gap-2">
        <Button type="button" disabled={busy || reason.trim().length < 3} onClick={() => onSend(m, reason.trim())}
          className="bg-amber-500 hover:bg-amber-400 text-black" data-testid="exists-different-send">{busy ? "Enviando…" : "Enviar como versión distinta"}</Button>
        <Button type="button" variant="ghost" onClick={onCancel}>Cancelar</Button>
      </div>
    </div>
  );
};

// Candado B en P5: la carta ya existe → publicar esa, o enviar como otra versión con motivo.
export const ExistsInCatalog = ({ matches, onPublish, onBack, onDifferent, busy }) => {
  const [dismiss, setDismiss] = useState(null);
  return (
    <div className="bg-[#111] border border-[#34D399]/40 rounded-md p-4 sm:p-6 space-y-4" data-testid="exists-in-catalog">
      <div>
        <div className="font-display text-lg sm:text-xl">Esta carta ya existe en el catálogo</div>
        <p className="text-sm text-neutral-400 mt-1">No hace falta registrarla: publícala directo con sus datos oficiales.</p>
      </div>
      <ul className="space-y-2">
        {matches.map((m) => (
          <li key={m.id} className="space-y-2">
            <Match m={m} onPublish={onPublish} onDismiss={setDismiss} />
            {dismiss?.id === m.id && onDifferent && <DifferentForm m={m} busy={busy} onSend={onDifferent} onCancel={() => setDismiss(null)} />}
          </li>
        ))}
      </ul>
      <button type="button" onClick={onBack} className="text-xs text-neutral-500 underline" data-testid="exists-back">Volver al formulario</button>
    </div>
  );
};
